import Model from './model'
export default class RestfulModel extends Model {
  static async $fetch (options) {
    const response = await this.$axios.get(this.endpoint, options)
    return this.insertOrUpdate({ data: response.data })
  }

  static async $get (id, options) {
    const response = await this.$axios.get(`${this.endpoint}/${id}`, options)
    return this.insertOrUpdate({ data: response.data })
  }

  static async $create (data, options) {
    let url = this.endpoint

    if (options && options.url) {
      url = url + options.url
    }

    const config = {
      ...(options || {}),
      url
    }
    const response = await this.$axios.post(url, data, config)

    return this.insertOrUpdate({ data: response.data })
  }

  static async $update (id, data, options) {
    let url = `${this.endpoint}/${id}`

    if (options && options.url) {
      url = url + options.url
    }

    const config = {
      ...(options || {}),
      url
    }

    const response = await this.$axios.put(url, data, config)

    return this.insertOrUpdate({ data: response.data })
  }

  static async $delete (id, options) {
    let url = `${this.endpoint}/${id}`

    if (options && options.url) {
      url = url + options.url
    }

    await this.$axios.delete(url, options)

    return this.delete(id)
  }
}
